module.exports = __webpack_public_path__ + "media/images/kaoawase/hall-list/kaoawase-halllist-3-3e352322b4cc7150c9512922978cd4b8.png";